import React from "react";
import axios from "axios";
import { PreviewLayout } from "./";
import { Lazy } from "@/components/Lazy";
import { Video } from "@/components/Video";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { isFileAblob } from "@/utils/qrEditorHelper";
import { useToast } from "@/hooks/ui/useToast";
import { InvalidVideoFormatToast, InvalidYTProviderToast } from "@/utils/uploadHelper";

export default function PreviewYoutube(props: QRProps<"youtube">) {
  const { toast } = useToast();
  const qrEditorContext = React.useContext<QREditorContextProps<"youtube">>(QREditorContext);
  const data = props?.data || qrEditorContext?.qrData.data;
  const isInitPreview = props?.initPreview;

  const [youtubeEmbedLink, setYoutubeEmbedLink] = React.useState("");
  const emptyDiv = `<iframe style="width: 100%; min-height: 246px; background-color: #595959" frameborder="0"></iframe>`;

  React.useEffect(() => {
    if (!isInitPreview) {
      if (data?.youtubeUrl) {
        axios
          .get(`https://www.youtube.com/oembed?url=${data?.youtubeUrl}`)
          .then((res) => {
            setYoutubeEmbedLink(res.data.html);
            qrEditorContext?.setValidationError(false);
          })
          .catch(() => {
            //ValidationError prevents Next button from moving to next step
            qrEditorContext?.setValidationError(true);
            setYoutubeEmbedLink(emptyDiv);
          });
      } else qrEditorContext?.setValidationError(true);
    }
  }, [data?.youtubeUrl]);

  const isIframeEmpty = () => {
    const iframe = document.querySelector("video");
    return iframe?.childNodes.length;
  };

  return (
    <PreviewLayout
      page="youtube"
      dataQA="preview-youtube-container"
      backgroundColor="#F2CFBA"
      includeBrowser
      isInitPreview={isInitPreview}>
      <>
        {isInitPreview ? (
          <div className="video-wrapper">
            <Lazy placeholderClass="skeleton-placeholder__youtube__image">
              <img
                src={data?.logoUrl}
                alt="youtube video preview"
              />
            </Lazy>
          </div>
        ) : (
          <>
            {isIframeEmpty() !== 0 && (
              <div className="video-wrapper">
                <Video
                  url={youtubeEmbedLink}
                  onReady={(isLoaded) => {
                    isLoaded ? setYoutubeEmbedLink(youtubeEmbedLink) : setYoutubeEmbedLink("");
                  }}
                  onError={() => {
                    const toastContent = isFileAblob(youtubeEmbedLink)
                      ? InvalidVideoFormatToast()
                      : InvalidYTProviderToast();

                    toast({
                      type: "custom",
                      content: () => toastContent,
                      marginBottom: 80,
                      duration: 10000,
                    });
                  }}
                />
              </div>
            )}
          </>
        )}
      </>
    </PreviewLayout>
  );
}
